(function () {
  const mobileNavUpdates = () => {
    const hamburger = document.querySelector("button.hamburger");
    const mainMenu = document.querySelector(".main-menu");
    var observer = new IntersectionObserver(function (entries) {
      var body = document.body;

      if (entries[0].isIntersecting) {
        body.classList.remove("scrolled");
        body.classList.add("top");
      } else {
        body.classList.remove("top");
        body.classList.add("scrolled");
      }
    });

    observer.observe(document.querySelector(".section-header-top-bar"));
  };
  const cartUpdates = () => {
    class CartWatcher {
      init() {
        this.emitCartChanges().then(() => {
          this.observeCartChanges();
        });
      }

      async fetchCart() {
        const response = await fetch("/cart.js");
        return response.json();
      }

      async emitCartChanges() {
        const newCart = await this.fetchCart();

        const event = new CustomEvent("cart_changed", { detail: newCart });
        window.dispatchEvent(event);
      }

      observeCartChanges() {
        const cartObserver = new PerformanceObserver((list) => {
          list.getEntries().forEach((entry) => {
            const isValidRequestType = ["xmlhttprequest", "fetch"].includes(
              entry.initiatorType
            );
            const isCartChangeRequest = /\/cart\//.test(entry.name);
            if (isValidRequestType && isCartChangeRequest) {
              this.emitCartChanges();
            }
          });
        });
        cartObserver.observe({ entryTypes: ["resource"] });
      }
    }

    const myCartWatcher = new CartWatcher();
    myCartWatcher.init();
    window.addEventListener("cart_changed", (e) => {
      const upSellItem = document.querySelector(".ajax-cart-upsell");

      if (upSellItem) {
        const upSellId = upSellItem.dataset.productId;
        if (e.detail.item_count) {
          upSellItem.classList.remove("hide");

          const upSellAdded = e.detail.items.some(
            (item) => item.id == upSellId
          );
          if (upSellAdded) {
            upSellItem.classList.add("hide");
          }
        } else {
          upSellItem.classList.add("hide");
        }
      }
    });
  };
  document.addEventListener("DOMContentLoaded", (event) => {
    mobileNavUpdates();
    cartUpdates();
  });
})();

if (!customElements.get("deferred-media")) {
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this.dataset.autoplay) {
        window.addEventListener("load", () => {
          this.loadContent();
        });
        return;
      }
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener("click", this.loadContent.bind(this));
    }

    loadContent(focus = true) {
      window.pauseAllMedia();
      if (!this.getAttribute("loaded")) {
        const content = document.createElement("div");
        content.appendChild(
          this.querySelector("template").content.firstElementChild.cloneNode(
            true
          )
        );

        this.setAttribute("loaded", true);
        const deferredElement = this.appendChild(
          content.querySelector("video, model-viewer, iframe")
        );
        if (focus) deferredElement.focus();
        if (
          deferredElement.nodeName == "VIDEO" &&
          deferredElement.getAttribute("autoplay")
        ) {
          // force autoplay for safari
          deferredElement.play();
        }
      }
    }
  }

  customElements.define("deferred-media", DeferredMedia);

  function pauseAllMedia() {
    document.querySelectorAll(".js-youtube").forEach((video) => {
      video.contentWindow.postMessage(
        '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
        "*"
      );
    });
    document.querySelectorAll(".js-vimeo").forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', "*");
    });
    document.querySelectorAll("video").forEach((video) => video.pause());
    document.querySelectorAll("product-model").forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }
}

if (!customElements.get("sticky-bottom")) {
  class StickyBottom extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const el = this;
      this.reference = this.dataset.reference;
      if (this.dataset.enabled == "false" || !this.reference) return;
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener("scroll", this.onScrollHandler, false);
      setTimeout(() => {
        el.onScroll();
      }, "1000");
    }

    onScroll() {
      const container = document.querySelector(this.reference);
      if (!container) return;
      const rect = container.getBoundingClientRect();
      let isOffScreen = rect.y + rect.height < 0 || rect.y > window.innerHeight;
      const offSetContainer = container.offsetTop;
      if (offSetContainer < window.scrollY && isOffScreen) {
        this.addSticky();
      } else {
        this.removeSticky();
      }
    }

    removeSticky() {
      document.body.classList.remove("sticky-bottom--active");
    }

    addSticky() {
      document.body.classList.add("sticky-bottom--active");
    }
  }
  customElements.define("sticky-bottom", StickyBottom);
}
if (!customElements.get("variant-selects")) {
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const el = this;
      this.addEventListener("change", el.onVariantChange.bind(this));
      this.addEventListener("custom-change", el.onVariantChange.bind(this));
      document.addEventListener("click", (e) => {
        this.customSelectHandler(e);
      });
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.updateVariantStatuses();
      if (!this.currentVariant) {
        this.toggleAddButton(true);
      } else {
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateMedia();
      }
    }

    updateOptions() {
      this.options = Array.from(
        this.querySelectorAll("select"),
        (select) => select.value
      );
    }

    updateMedia() {
      if (this.currentVariant && this.currentVariant.featured_media) {
        const gallery = document.querySelector("[data-product-images-slider]");
        if (!gallery) {
          return;
        }
        gallery.dispatchEvent(
          new CustomEvent("go-to-slide", {
            detail: { position: this.currentVariant.featured_media.position },
          })
        );
      }
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }

    updateVariantStatuses() {
      const selectedOptionOneVariants = this.variantData.filter(
        (variant) => this.querySelector(":checked").value === variant.option1
      );
      const inputWrappers = [...this.querySelectorAll(".product-form__input")];
      inputWrappers.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [
          ...option.querySelectorAll('input[type="radio"], option'),
        ];
        const previousOptionSelected =
          inputWrappers[index - 1].querySelector(":checked").value;
        const availableOptionInputsValue = selectedOptionOneVariants
          .filter(
            (variant) =>
              variant.available &&
              variant[`option${index}`] === previousOptionSelected
          )
          .map((variantOption) => variantOption[`option${index + 1}`]);
        this.setInputAvailability(optionInputs, availableOptionInputsValue);
      });
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach((input) => {
        if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
          input.innerText = input.getAttribute("value");
        } else {
          input.innerText =
            window.variantStrings.unavailable_with_option.replace(
              "[value]",
              input.getAttribute("value")
            );
        }
      });
    }

    renderProductInfo() {
      const requestedVariantId = this.currentVariant.id;

      fetch(
        `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
          this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
        }`
      )
        .then((response) => response.text())
        .then((responseText) => {
          // prevent unnecessary ui changes from abandoned selections
          if (this.currentVariant.id !== requestedVariantId) return;

          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const priceWrapperSource = html.querySelector(
            "[data-product-price-wrapper]"
          );
          const priceWrapperDestination = document.querySelectorAll(
            "[data-product-price-wrapper]"
          );
          if (priceWrapperSource && priceWrapperDestination)
            priceWrapperDestination.forEach(
              (priceEl) => (priceEl.innerHTML = priceWrapperSource.innerHTML)
            );
          const priceSource = html.querySelector("[data-product-price]");
          const priceDestination = document.querySelectorAll(
            "[data-product-price]"
          );
          if (priceSource && priceDestination)
            priceDestination.forEach(
              (priceEl) => (priceEl.innerHTML = priceSource.innerHTML)
            );
        });
    }

    toggleAddButton(disable = true) {
      const productForm = document.getElementById(
        `product-form-${this.dataset.section}`
      );
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute("disabled", "disabled");
      } else {
        addButton.removeAttribute("disabled");
      }
    }

    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    customSelectHandler(clickedElement) {
      if (this.contains(clickedElement.target)) {
        const customSelect = clickedElement.target.closest(
          "[data-custom-select]"
        );
        const customOption = clickedElement.target.hasAttribute(
          "data-custom-option"
        )
          ? clickedElement.target
          : clickedElement.target.closest("[data-custom-option]");
        if (customOption) {
          clickedElement.stopPropagation();
          this.customSelectUpdate(customSelect, customOption);
        } else if (customSelect) {
          this.customSelectUpdate(customSelect);
        } else {
          this.closeCustomSelects();
        }
      } else {
        this.closeCustomSelects();
      }
    }

    customSelectUpdate(customSelect, option = "") {
      if (!customSelect) return;
      const mainSelect = document.querySelector(
        `${customSelect.dataset.mainSelect}`
      );
      const selectedValue = customSelect.querySelector(
        "[data-selected-option]"
      );
      if (!mainSelect || !selectedValue) return;
      if (option) {
        mainSelect.value = option.dataset.value;
        selectedValue.innerHTML = option.innerHTML;
        mainSelect.dispatchEvent(new Event("change", { bubbles: true }));
        customSelect.classList.toggle("custom-select--active");
        const activeOption = customSelect.querySelector(
          ".custom-select__option--active"
        );
        if (activeOption) {
          activeOption.classList.remove("custom-select__option--active");
        }
        option.classList.add("custom-select__option--active");
      } else {
        this.closeCustomSelects(customSelect.id);
        customSelect.classList.toggle("custom-select--active");
      }
    }

    closeCustomSelects(customSelectId) {
      document
        .querySelectorAll(".custom-select--active")
        .forEach((customSelect) => {
          if (customSelect.id == customSelectId) return;
          customSelect.classList.remove("custom-select--active");
        });
    }
  }

  customElements.define("variant-selects", VariantSelects);

  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach((input) => {
        if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
          input.classList.remove("disabled");
        } else {
          input.classList.add("disabled");
        }
      });
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      });
    }
  }
  customElements.define("variant-radios", VariantRadios);
}
if(!customElements.get('swipe-cards')) {
  class SwipeCards extends HTMLElement {
    constructor() {
      super();
      console.log(this)
    }

  }
  customElements.define("swipe-cards", SwipeCards);
}
